module.exports = __webpack_public_path__ + "static/media/send-disabled.beda8323.svg";